import { render, staticRenderFns } from "./OnlineStore.vue?vue&type=template&id=fdcb1140&scoped=true&"
import script from "./OnlineStore.vue?vue&type=script&lang=js&"
export * from "./OnlineStore.vue?vue&type=script&lang=js&"
import style0 from "./OnlineStore.vue?vue&type=style&index=0&id=fdcb1140&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdcb1140",
  null
  
)

export default component.exports